export default function getInitialState() {
  return {
    isStandupOn: false,
    currentSpeaker: undefined,
    pastSpeakers: [],
    wasNextRecentlyClicked: false,
    isPlayingFocusAnimation: false
  };
}
